// 매거진(공구 매거진) 현황판 - 순수 로직/포맷. eqpToolDiagFormat.js와 같은 이유로 컴포넌트와 분리.
import dayjs from 'dayjs';

// 매거진 매핑이 아직 설정 안 됐으면(장비 옵션에 magazine 없음) 빈 배열이 아니라 null/undefined로 온다.
export const hasMagazine = (magazine) => Array.isArray(magazine) && magazine.length > 0;

// 포트에 공구가 없는(빈 칸) 상태 - tool이 없거나 0번(관례상 "비어있음")이면 그레이 처리 대상.
export const isEmptyPot = (pot) => !pot || pot.tool == null || pot.tool === 0;

// 오늘 공구 교환 이력을 화면 표 행으로 - 시각/이전 공구/새 공구.
export const formatToolChangeRows = (toolChanges) => {
  if (!Array.isArray(toolChanges)) return [];
  return toolChanges.map((c) => ({
    time: c?.chgDt ? dayjs(c.chgDt).format('HH:mm:ss') : '-',
    prevTool: c?.prevToolNo != null ? String(c.prevToolNo) : '-',
    tool: c?.toolNo != null ? String(c.toolNo) : '-',
  }));
};

// "현재 공구로 바뀐 시각" - 기록이 없으면 null(화면은 "-" 등으로 처리).
export const formatCurToolSince = (iso) => (iso ? dayjs(iso).format('YYYY-MM-DD HH:mm:ss') : null);
